import { createRoot } from "react-dom/client";
import { ensureDataLayer } from "./lib/tracking";
import App from "./App.tsx";
import "./index.css";

// Initialize dataLayer as early as possible, before React mounts
if (typeof window !== 'undefined') {
  ensureDataLayer();
}

createRoot(document.getElementById("root")!).render(<App />);
